import React, { Component } from 'react'
import moment from '../../utils/helpers/moment'
import DevisRecap from '../DevisRecap'
import CapitalDeces from '../CapitalDeces'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getRecap } from '../../utils/helpers/recapBudget'
import { fetchUpdateSouscripteurAction } from '../../actions/Souscription/Souscripteur'

class BeneficiaireTable extends Component {
  static propTypes = {
    beneficiaires: PropTypes.array.isRequired,
    checkChangeBeneficiaire: PropTypes.func.isRequired,
    souscripteurID: PropTypes.string.isRequired,
  }
  constructor(props) {
    super(props)
    let thisBeneficiaires = props.beneficiaires
    let devisBeneficiaires = []

    if (thisBeneficiaires) {
      for (var i = 0; i < thisBeneficiaires.length; i++) {
        let currentBeneficiaire =
        {
          _id: `${thisBeneficiaires[i]._id}`,
          firstname: `${thisBeneficiaires[i].firstname}`,
          lastname: `${thisBeneficiaires[i].lastname}`,
          formule: `${thisBeneficiaires[i].formule}`,
          primeSante: this.primeSante(thisBeneficiaires[i].birthday, thisBeneficiaires[i].formule),
          optionAccidents: thisBeneficiaires[i].optionAccidents,
          primeAccidents: thisBeneficiaires[i].primeAccidents,
          birthday: thisBeneficiaires[i].birthday,
          lien: thisBeneficiaires[i].lien,
          noOption: isYounger(thisBeneficiaires[i].birthday, 18),
          capitalDecesClauseType: thisBeneficiaires[i].capitalDecesClauseType,
        }
        devisBeneficiaires.push(currentBeneficiaire)
      }

      //Patch Souscripteur entity with Devis Recap
      props.userUpdateSouscripteur(props.souscripteurID, { budgetBeneficiaires: getRecap(devisBeneficiaires) })
    }
    //Patch beneficiare entity
    props.checkChangeBeneficiaire(devisBeneficiaires)
    this.state = { allDevisBeneficiaires: devisBeneficiaires }
  }

  primeSante(birthday, formule) {
    let age = moment().diff(moment(birthday, "DD-MMM-YYYY"), 'years')

    if (formule === "premier") {
      if (ageBetween(age, 0, 18)) return 60000
      if (ageBetween(age, 19, 30)) return 100000
      if (ageBetween(age, 31, 50)) return 150000
      if (ageBetween(age, 51, 65)) return 200000
    } else if (formule === "vitalite") {
      if (ageBetween(age, 0, 18)) return 80000
      if (ageBetween(age, 19, 30)) return 120000
      if (ageBetween(age, 31, 50)) return 170000
      if (ageBetween(age, 51, 65)) return 250000
    } else if (formule === "prestige") {
      if (ageBetween(age, 0, 18)) return 100000
      if (ageBetween(age, 19, 30)) return 150000
      if (ageBetween(age, 31, 50)) return 200000
      if (ageBetween(age, 51, 65)) return 300000
    }
    return 0
  }

  handleChangeFormule(event, index) {
    let formule = event.target.value

    this.setState(
      (prevState, props) => {
        let data = prevState.allDevisBeneficiaires
        data[index].formule = formule

        data[index].primeSante = this.primeSante(data[index].birthday, formule)
        return { allDevisBeneficiaires: data }
      })

    const { beneficiaires, checkChangeBeneficiaire, souscripteurID, userUpdateSouscripteur } = this.props
    let currNewAllBeneficiaires = beneficiaires
    currNewAllBeneficiaires[index].formule = formule
    currNewAllBeneficiaires[index].primeSante = this.primeSante(currNewAllBeneficiaires[index].birthday, formule)
    //Patch Souscripteur entity with Devis Recap
    userUpdateSouscripteur(souscripteurID, { budgetBeneficiaires: getRecap(currNewAllBeneficiaires) })

    checkChangeBeneficiaire(currNewAllBeneficiaires)
  }

  handleChangeoptionAccidents(event, index) {
    let optionAccidents = event.target.value
    let correspondances = {
      0: 0,
      3500000: 10000,
      5250000: 15000,
      7000000: 20000,
    }
    this.setState(
      (prevState, props) => {
        let data = prevState.allDevisBeneficiaires

        data[index].optionAccidents = optionAccidents
        data[index].primeAccidents = correspondances[optionAccidents]
        return { allDevisBeneficiaires: data }
      })

    const { beneficiaires, checkChangeBeneficiaire, souscripteurID, userUpdateSouscripteur } = this.props
    let currNewAllBeneficiaires = beneficiaires
    currNewAllBeneficiaires[index].optionAccidents = optionAccidents
    currNewAllBeneficiaires[index].primeAccidents = correspondances[optionAccidents]
    //Patch Souscripteur entity with Devis Recap
    userUpdateSouscripteur(souscripteurID, { budgetBeneficiaires: getRecap(currNewAllBeneficiaires) })

    checkChangeBeneficiaire(currNewAllBeneficiaires)
  }
  checkCapitalDeces = (beneficiaireID, capitalDeces) => {
    this.setState((prevState) => {
      let data = prevState.allDevisBeneficiaires.map((beneficiaire) => {
        if (beneficiaire._id === beneficiaireID) {
          beneficiaire.capitalDecesClauseType = capitalDeces
        }
        return beneficiaire
      })
      return { allDevisBeneficiaires: data }
    })
    const { beneficiaires, checkChangeBeneficiaire } = this.props
    let currNewAllBeneficiaires = beneficiaires.map((beneficiaire) => {
      if (beneficiaire._id === beneficiaireID) {
        beneficiaire.capitalDecesClauseType = capitalDeces
      }
      return beneficiaire
    })
    checkChangeBeneficiaire(currNewAllBeneficiaires)
  }

  render() {
    const { allDevisBeneficiaires } = this.state

    return (
      <div>
        <div className="aps-dashboard-devis-date-content-show-web">
          <table className="uk-table uk-table-divider">
            <thead>
              <tr>
                <th className="aps-dashboard-table-head aps-dashboard-table-content-space-one">
                  <div className="uk-text-center">
                    N°
                  </div>
                </th>
                <th className="aps-dashboard-table-head aps-dashboard-table-content-space-second">
                  <div className="uk-text-center">
                    Nom et prénoms
                  </div>
                </th>
                <th className="aps-dashboard-table-head aps-dashboard-table-content-space-third">
                  <div className="uk-text-center">
                    Formule
                  </div>
                </th>
                <th className="aps-dashboard-table-head aps-dashboard-table-content-space-four">
                  <div className="uk-text-center">
                    Prime santé
                  </div>
                </th>
                <th className="aps-dashboard-table-head aps-dashboard-table-content-space-five aps-box-clip-full">
                  <div className="uk-text-center">
                    Option "Prévoyance Familiale"
                  </div>
                </th>
                <th className="aps-dashboard-table-head aps-dashboard-table-content-space-six">
                  Prime PF
                </th>
              </tr>
            </thead>
            <tbody>

              {Object.keys(allDevisBeneficiaires).length !== 0 &&
                allDevisBeneficiaires.map((currBeneficiaire, index) => (
                  <tr key={index}>
                    <td className="aps-dashboard-table-data uk-text-center">
                      <div className="aps-dashboard-table-data-content uk-text-bold">
                        {index + 1}
                      </div>
                    </td>
                    <td className="aps-dashboard-table-data uk-text-bold uk-text-center">
                      <Link
                        className="aps-dashboard-table-data-fullname"
                        to={{ pathname: '/beneficiaire', state: { fromDevisTable: true, position: index } }}>
                        {currBeneficiaire.firstname} {currBeneficiaire.lastname}
                      </Link>
                    </td>
                    <td className="aps-dashboard-table-data uk-text-center">
                      <div className="aps-dashboard-table-data-content uk-text-bold">
                        <select value={currBeneficiaire.formule} onChange={(event) => this.handleChangeFormule(event, index)} className="aps-dashboard-table-select uk-select">
                          <option value="premier">Premier</option>
                          <option value="vitalite">Vitalité</option>
                          <option value="prestige">Prestige</option>
                        </select>
                      </div>
                    </td>
                    <td className="aps-dashboard-table-data aps-dashboard-table-montant uk-text-center">
                      <div className="aps-dashboard-table-data-content uk-text-bold">
                        {currBeneficiaire.primeSante.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                      </div>
                    </td>

                    {currBeneficiaire.noOption
                      ?
                      <td className="aps-dashboard-table-data aps-dashboard-table-montant">
                        <div className="aps-dashboard-table-data-content uk-text-bold">
                          <span title="Ce bénéficiaire a moins de 18 ans, il ne peut donc pas souscrire à cette option." data-uk-tooltip>Invalide</span>
                        </div>
                      </td>
                      :
                      <td className="aps-dashboard-table-data">
                        <div className="aps-dashboard-table-data-content uk-text-bold">
                          <select value={currBeneficiaire.optionAccidents} onChange={(event) => this.handleChangeoptionAccidents(event, index)} className="aps-dashboard-table-select aps-dashboard-table-select-center uk-select aps-dashboard-table-select-color-green">
                            <option value={0}>Choisir</option>
                            <option value={3500000}>3 500 000</option>
                            <option value={5250000}>5 250 000</option>
                            <option value={7000000}>7 000 000</option>
                          </select>
                        </div>
                      </td>
                    }

                    <td className="aps-dashboard-table-data aps-dashboard-table-montant">
                      {currBeneficiaire.noOption
                        ?
                        <div className="aps-dashboard-table-data-content uk-text-bold">
                          <span title="Ce bénéficiaire a moins de 18 ans, il ne peut donc pas souscrire à cette option." data-uk-tooltip>Non</span>
                        </div>
                        :
                        <div className="aps-dashboard-table-data-content uk-text-bold">
                          {
                            currBeneficiaire.primeAccidents.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                          }
                        </div>
                      }
                    </td>
                  </tr>
                ))
              }

            </tbody>
          </table>
        </div>
        <div style={{ display: "none" }} className="aps-dashboard-devis-date-content-show-mobile aps-dashboard-devis-mobile-beneficiare-box">
          {Object.keys(allDevisBeneficiaires).length !== 0 &&
            allDevisBeneficiaires.map((currBeneficiaire, index) => (
              <div key={index}>
                <table className="uk-table uk-table-divider">
                  <tbody>
                    <tr>
                      <td className="aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
                        <Link
                          className="aps-dashboard-table-data-fullname"
                          style={{ fontWeight: "600" }}
                          to={{ pathname: '/beneficiaire', state: { fromDevisTable: true, position: index } }}>
                          {index + 1}- {currBeneficiaire.firstname} {currBeneficiaire.lastname}
                        </Link>
                      </td>
                      <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">

                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "0px" }} className="aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
                        Formule
                      </td>
                      <td style={{ padding: "0px" }} className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
                        <select value={currBeneficiaire.formule} onChange={(event) => this.handleChangeFormule(event, index)} className="aps-dashboard-table-select uk-select">
                          <option value="premier">Premier</option>
                          <option value="vitalite">Vitalité</option>
                          <option value="prestige">Prestige</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
                        Prime santé
                      </td>
                      <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
                        {currBeneficiaire.primeSante.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                      </td>
                    </tr>
                    <tr>
                      <td className="aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
                        Option "Prévoyance Familiale"
                      </td>
                      <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
                        {currBeneficiaire.noOption
                          ?
                          <span title="Ce bénéficiaire a moins de 18 ans, il ne peut donc pas souscrire à cette option." data-uk-tooltip>Invalide</span>
                          :
                          <select value={currBeneficiaire.optionAccidents} onChange={(event) => this.handleChangeoptionAccidents(event, index)} className="aps-dashboard-table-select uk-select aps-dashboard-table-select-color-green">
                            <option value={0}>Choisir</option>
                            <option value={3500000}>3 500 000</option>
                            <option value={5250000}>5 250 000</option>
                            <option value={7000000}>7 000 000</option>
                          </select>
                        }
                      </td>
                    </tr>
                    <tr>
                      <td className="aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
                        Prime PF
                      </td>
                      <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
                        {currBeneficiaire.noOption
                          ?
                          <span title="Ce bénéficiaire a moins de 18 ans, il ne peut donc pas souscrire à cette option." data-uk-tooltip>Non</span>
                          :
                          <div className="">
                            {currBeneficiaire.primeAccidents.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                          </div>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr className="aps-btn-mobile-beneficiaire-pre-header-divider" />
              </div>
            ))
          }
        </div>

        <div className="aps-dashboard-devis-capital-deces" hidden={allDevisBeneficiaires.filter((beneficiaire) => beneficiaire.primeAccidents !== 0).length === 0}>
          <p className="uk-text-bold uk-text-medium aps-capital-deces-title">Bénéficiaires du capital décès :</p>
          <CapitalDeces checkFormValid={this.props.checkFormValid} checkCapitalDeces={this.checkCapitalDeces} beneficiaires={allDevisBeneficiaires.filter((beneficiaire) => beneficiaire.primeAccidents !== 0)} />
        </div>
        <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
          <div className="uk-width-1-6 aps-section-alerte-green-arrow-right aps-simulation-v2-checkbox-mg-individual-acc-item">
            <i className="fa fa-info-circle aps-simulation-v2-picto-infos"></i>
          </div>
          <div className="uk-width-expand aps-section-alerte-green-expand">
            <p className="aps-section-alerte-green-content-full uk-text-justify aps-simulation-v2-checkbox-mg-bolder">
              La garantie "Prévoyance Familiale" permet de payer un capital décès aux ayants droit de l'assuré en cas de décès 
              toutes causes ou un capital invalidité à l'assuré lui-même en cas d'invalidité totale et définitive.
            </p>
          </div>
        </div>
        <div className="">
          <p className="uk-text-bold aps-dashboard-devis-recap-title">Récapitulatif du devis</p>
          <DevisRecap allDevisBeneficiaires={allDevisBeneficiaires} /> 
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ updateSouscripteur }) => {
  return {
    updateSouscripteur,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    userUpdateSouscripteur: (souscripteurID, souscripteurData) => dispatch(fetchUpdateSouscripteurAction(souscripteurID, souscripteurData)),
  }
}
/*
function isOlder(birthday, limitAge) {
  let age = moment().diff(moment(birthday, "DD-MMM-YYYY"), 'years')
  return age > limitAge
}*/
function isYounger(birthday, limitAge) {
  let age = moment().diff(moment(birthday, "DD-MMM-YYYY"), 'years')
  return age < limitAge
}
function ageBetween(age, lower, upper) {
  return lower <= age && age <= upper
}
export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaireTable)



// WEBPACK FOOTER //
// ./src/components/BeneficiaireTable/index.js